import React from 'react'

const ErrorIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.0152 32C24.8433 32 31.993 24.8366 31.9846 16C31.9761 7.16344 24.8127 0 15.9846 0C7.15656 0 0.00684737 7.16344 0.015294 16C0.0237407 24.8366 7.18715 32 16.0152 32Z"
        fill="#C72B42"
      />
      <path
        d="M20.0121 10.3796L15.9326 14.1017L11.8531 10.3796C11.1927 9.7771 10.122 9.7771 9.46159 10.3796C8.80121 10.9821 8.80121 11.959 9.46159 12.5615L13.5411 16.2836L9.46159 20.0057C8.80183 20.6088 8.80283 21.5856 9.46384 22.1876C10.124 22.7887 11.1929 22.7887 11.8531 22.1876L15.9326 18.4655L20.0121 22.1876C20.6732 22.7895 21.7438 22.7886 22.4036 22.1855C23.0625 21.5833 23.0625 20.608 22.4036 20.0057L18.3241 16.2836L22.4036 12.5615C23.064 11.959 23.064 10.9821 22.4036 10.3796C21.7432 9.7771 20.6725 9.7771 20.0121 10.3796Z"
        fill="white"
      />
    </svg>
  )
}

export default ErrorIcon
